import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { handleBuyClick } from './utils/metaPixel';
export const OfferBlock = () => {
  return <section id="oferta" className="py-24 bg-dark relative overflow-hidden scroll-mt-16" data-id="element-97">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-neon/10 rounded-full blur-[100px] pointer-events-none" data-id="element-98" />

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-99">
        {/* Price card */}
        <div className="bg-dark-card border border-neon/30 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(163,255,18,0.1)] mb-16" data-id="element-100">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-101">
            {/* Image */}
            <div className="flex-1 w-full max-w-sm lg:max-w-none" data-id="element-102">
              <FadeIn data-id="element-103">
                <img src="https://cdn.magicpatterns.com/uploads/i98tbdWAFmDMydmCtG4nes/efectivo_inmediato_48_horas.png" alt="Plan de Emergencia Financiera de 48 Horas" className="w-full h-auto drop-shadow-2xl" data-id="element-104" />
              </FadeIn>
            </div>

            {/* Content */}
            <div className="flex-1 text-center lg:text-left w-full" data-id="element-105">
              <FadeIn delay={0.2} data-id="element-106">
                <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight" data-id="element-107">
                  Accede hoy por solo{' '}
                  <span className="text-neon" data-id="element-108">$6.39 USD</span>
                </h2>

                <p className="text-lg text-gray-300 mb-3 leading-relaxed font-sans" data-id="element-109">
                  Normalmente este tipo de sistemas se venden entre{' '}
                  <span className="text-gray-500 line-through" data-id="element-110">
                    $47 y $97 USD
                  </span>
                  .
                </p>
                <p className="text-lg text-gray-300 mb-3 leading-relaxed font-sans" data-id="element-111">
                  Por el lanzamiento de esta semana puedes acceder por solo{' '}
                  <span className="text-white font-semibold" data-id="element-112">$6.39 USD</span>.
                </p>
                <p className="text-lg mb-8 leading-relaxed font-sans" data-id="element-113">
                  <span className="text-[#ADFF2F] font-semibold" data-id="element-114">
                    El viernes el precio sube a $27 USD y no habrá excepciones.
                  </span>
                </p>

                <div id="precio-final" className="mb-2 flex items-baseline gap-3 justify-center lg:justify-start scroll-mt-24" data-id="element-115">
                  <span className="text-6xl md:text-7xl text-neon font-display drop-shadow-[0_0_15px_rgba(163,255,18,0.5)]" data-id="element-116">
                    $6.39
                  </span>
                  <span className="text-2xl text-white" data-id="element-117">USD</span>
                </div>
                <p className="text-sm text-gray-400 mb-6 font-sans" data-id="element-118">
                  Pago único · Sin mensualidad · Acceso de por vida
                </p>

                <Button className="w-full py-5 text-lg md:text-xl" showIcon={false} onClick={handleBuyClick} data-id="element-119">
                  ⚡ QUIERO ACCESO INMEDIATO — $6.39
                </Button>
                <p className="text-sm text-[#ADFF2F] font-semibold mt-3 font-sans" data-id="element-120">
                  El precio sube el viernes
                </p>

                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-3 gap-y-2 text-sm text-gray-400 mt-4" data-id="element-121">
                  <span data-id="element-122">🕐 Acceso instantáneo</span>
                  <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-123" />
                  <span data-id="element-124">✅ Pago seguro</span>
                  <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-125" />
                  <span data-id="element-126">📥 Descarga inmediata</span>
                  <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-127" />
                  <span data-id="element-128">🛡️ Garantía 7 días</span>
                </div>
              </FadeIn>
            </div>
          </div>
        </div>

        {/* Closing question */}
        <FadeIn data-id="element-129">
          <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-130">
            <p className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-131">
              La única pregunta que importa ahora es:
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-8" data-id="element-132">
              En 48 horas puedes estar leyendo esto con tu primer pago recibido.
              O puedes seguir en la misma situación.{' '}
              <span className="text-neon" data-id="element-133">¿Qué eliges?</span>
            </h2>

            <div className="space-y-4 text-left md:text-center max-w-2xl mx-auto" data-id="element-134">
              <p className="text-base md:text-lg text-gray-300 leading-relaxed font-sans m-0" data-id="element-135">
                Esta semana van a pasar 48 horas de todas formas.
              </p>
              <p className="text-base md:text-lg text-gray-300 leading-relaxed font-sans m-0" data-id="element-136">
                La diferencia es si al final de esas 48 horas tienes dinero
                extra en tu cuenta o sigues esperando que algo cambie solo.
              </p>
              <p className="text-base md:text-lg text-white leading-relaxed font-sans m-0" data-id="element-137">
                El plan cuesta{' '}
                <span className="text-[#ADFF2F] font-bold" data-id="element-138">$6.39</span>. La
                garantía es total. El acceso es inmediato.
              </p>
              <p className="text-lg md:text-xl text-[#ADFF2F] font-bold leading-relaxed font-sans m-0" data-id="element-139">
                No hay razón para esperar.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Final CTA */}
        <FadeIn delay={0.2} data-id="element-140">
          <div id="cta-final" className="flex flex-col items-center gap-3 scroll-mt-24" data-id="element-141">
            <Button className="w-full sm:w-auto py-5 text-lg md:text-xl" showIcon={false} onClick={handleBuyClick} data-id="element-142">
              ⚡ EMPIEZO HOY POR SOLO $6.39 USD
            </Button>
            <p className="text-sm text-[#ADFF2F] font-semibold font-sans" data-id="element-143">
              Precio sube el viernes a $27
            </p>

            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm text-gray-400 mt-2" data-id="element-144">
              <span data-id="element-145">🕐 Acceso instantáneo</span>
              <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-146" />
              <span data-id="element-147">✅ Pago seguro</span>
              <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-148" />
              <span data-id="element-149">📥 Descarga inmediata</span>
              <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-150" />
              <span data-id="element-151">🛡️ Garantía 7 días</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};